export default __webpack_public_path__ + "static/media/FAC2.09f97172.jpg";